import type {
  BetterstartCommandRuntime,
  UpdateCommandOptions
} from '@cli-types/core-engine/commands.js'
import { renderCommandHelpText } from '@core-engine/templates/renderers/commands/command-help.js'
import { Command } from 'commander'

export function createUpdateCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('update')
    .alias('update-component')
    .description('Update Admin components from the latest CLI templates')
    .argument('[components...]', 'Component names to update (e.g., media-field button)')
    .option('--list', 'List all available components')
    .option('--json', 'With --list, print components as JSON on stdout', false)
    .option('--all', 'Update all components')
    .option('--shadcn-preset <preset>', 'Apply a shadcn preset to Admin UI components')
    .option('--only <parts>', 'Apply only supported shadcn preset parts: theme')
    .option('-y, --yes', 'Skip the overwrite confirmation', false)
    .option('--cwd <path>', 'Project root path')
    .addHelpText('after', renderCommandHelpText('update'))
    .action((components: string[], options: UpdateCommandOptions) =>
      runtime.runUpdate(components, options)
    )
}
